import { platformService } from '@/services/PlatformService';
const state = {
    platforms: [
        { name: 'Shopify', status: 'disconnected', orders: [], error: null },
        { name: 'Wix', status: 'disconnected', orders: [], error: null },
        { name: 'eBay', status: 'disconnected', orders: [], error: null },
        { name: 'Etsy', status: 'disconnected', orders: [], error: null },
        { name: 'Walmart', status: 'disconnected', orders: [], error: null },
    ],
    loading: false,
    error: null,
};
const mutations = {
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    UPDATE_PLATFORM_STATUS(state, { name, status }) {
        const platform = state.platforms.find((p) => p.name === name);
        if (platform)
            platform.status = status;
    },
    SET_PLATFORM_ORDERS(state, { name, orders }) {
        const platform = state.platforms.find((p) => p.name === name);
        if (platform)
            platform.orders = orders;
    },
    SET_PLATFORM_ERROR(state, { name, error }) {
        const platform = state.platforms.find((p) => p.name === name);
        if (platform)
            platform.error = error;
    },
};
const actions = {
    // Connect a platform (ex: authenticate or fetch token)
    // async connectPlatform(
    //   { commit }: ActionContext<PlatformState, RootState>,
    //   name: string
    // ) {
    //   try {
    //     commit("SET_LOADING", true);
    //     commit("SET_ERROR", null);
    //     await platformService.connectPlatform(name);
    //     commit("UPDATE_PLATFORM_STATUS", { name, status: "connected" });
    //   } catch (error: any) {
    //     commit("UPDATE_PLATFORM_STATUS", { name, status: "error" });
    //     commit("SET_PLATFORM_ERROR", {
    //       name,
    //       error: error.message || `Failed to connect ${name}`,
    //     });
    //     throw error;
    //   } finally {
    //     commit("SET_LOADING", false);
    //   }
    // },
    // Fetch order data from a platform
    async fetchOrders({ commit }, name) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            const response = await platformService.fetchAllOrders(name);
            commit('SET_PLATFORM_ORDERS', { name, orders: response || [] });
            return response;
        }
        catch (error) {
            commit('SET_PLATFORM_ERROR', {
                name,
                error: error.message || `Failed to fetch orders from ${name}`,
            });
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    // Disconnect a platform
    // async disconnectPlatform(
    //   { commit }: ActionContext<PlatformState, RootState>,
    //   name: string
    // ) {
    //   try {
    //     commit("SET_LOADING", true);
    //     await platformService.disconnectPlatform(name);
    //     commit("UPDATE_PLATFORM_STATUS", { name, status: "disconnected" });
    //   } catch (error: any) {
    //     commit("SET_PLATFORM_ERROR", {
    //       name,
    //       error: error.message || `Failed to disconnect ${name}`,
    //     });
    //     throw error;
    //   } finally {
    //     commit("SET_LOADING", false);
    //   }
    // },
};
const getters = {
    platforms: (state) => state.platforms,
    platformStatus: (state) => (name) => state.platforms.find((p) => p.name === name)?.status,
    platformOrders: (state) => (name) => state.platforms.find((p) => p.name === name)?.orders || [],
    loading: (state) => state.loading,
    error: (state) => state.error,
};
const platform = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
export default platform;
